var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFactoryIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.459 10c0-.369.298-.667.667-.667h2c.368 0 .666.298.666.667v2a.667.667 0 01-.666.666h-2A.667.667 0 013.459 12v-2zm1.333.666v.667h.667v-.667h-.667zM9.458 9.333A.667.667 0 008.79 10v2c0 .368.298.666.667.666h2a.667.667 0 00.666-.666v-2a.667.667 0 00-.666-.667h-2zm.666 2v-.667h.667v.667h-.667z",
    fill: "#242424"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.836 1.292A.667.667 0 0111.5.667h2.74c.357 0 .65.282.665.64l.551 13.332a.667.667 0 01-.666.695H1.458a.667.667 0 01-.667-.667V4.471a.667.667 0 011.015-.568L5.537 6.19l.125-1.767a.667.667 0 011.007-.526l3.859 2.303.308-4.91zM12.127 2l-.337 5.375a.667.667 0 01-1.007.531L6.916 5.598l-.127 1.783a.667.667 0 01-1.013.52L2.124 5.663V14h11.972l-.495-12h-1.474z",
    fill: "#242424"
  })));
}

export default SvgFactoryIcon;